<template>
  <div class="home">

    <div class="home__hero">
      <img src="../assets/image/home_hero.png" width="784" height="200" alt="えるかつ！">
    </div>

    <section id="castlist"/>
    <div class="section concept" v-if="userType != 'patron'">
      <div class="container has-text-centered">
        <h1 class="concept__title">えるかつ！へようこそ</h1>
        <div class="concept__text">
          人と魔物が共存してはやX年・・・<br>
          一見平和に見えるこの世界は、<br>
          様々な問題を抱えていた。<br>
          失踪するエルフ達！帰らぬエルフ達！<br>
          はたして、この世界に降り立った勇者は<br>
          エルフの里を復興する事ができるのか？？
        </div>
        <div class="columns is-centered button__area">
          <div class="column is-half">
            <button disabled style="width:100%;height:50px;margin-inline:auto;background:#ccc;border-radius:9999px;font-size:21px;">えるかつ！無料会員登録</button>
            <p style="color:#fff;font-size:14px;">えるかつ！は9/27をもってサービスを終了致しました。</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section cast cast--online" v-if="userType == 'patron'">
      <div class="container is-max-widescreen">
        <h2 class="cast__title home__header has-text-centered">しゅっきんちゅう</h2>
        <div class="home__contentswrap">
          <ul class="cast__list">
            <li class="cast__item" v-for="cast in liveCastList" :key="cast.id">
              <div class="cast__image">
                <router-link :to="`/live/streaming/${cast.liveId}?type=${cast.liveType}`">
                  <img :src="cast.photoURL" alt="">
                </router-link>
              </div>
              <div class="cast__name">{{ cast.nickname }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section" v-if="userType == 'patron'">
      <div class="container is-max-widescreen">
        <div class="home__contentswrap">
          <div class="container is-max-widescreen" style="text-align:center;color:red;font-size:14px;">
            えるかつ！は9/27（金）23時半で全てのサービスが終了致しました。<br>
            長らくのご来店、きゃすと達との出会い全てに御礼申し上げます。<br>
            なお、有償ゴールドの余りにつきましては、ご希望の勇者様のみ余り分のみの返金対応を行わせて頂きますので、当ページ最下部のお問合せより返金希望の旨をご連絡頂けますようお願い致します。<br>
            （最終受付：2025年11月30日23時59分まで。以降のお問合せにはお応えしかねますのでご注意ください。）
          </div>
        </div>
      </div>
    </div>

    <div class="section cast">
      <div class="container is-max-widescreen">
        <h2 class="cast__title home__header has-text-centered">きゃすと</h2>
        <div class="home__contentswrap">

            <ul class="cast__list">
              <li class="cast__item" v-for="cast in castList" :key="cast.id">
                <div class="cast__image">
                  <router-link :to="`/castinfo/${cast.castId}`">
                    <img :src="require(`../assets/image/cast/${cast.id}.png`)" alt="">
                  </router-link>
                </div>
                <div class="cast__name">{{ cast.name }}</div>
                <!-- <div class="cast__intro" v-html="cast.info"></div> -->
              </li>
            </ul>

        </div>
      </div>
    </div>

    <div class="section manager">
      <div class="container is-max-widescreen">
        <h2 class="manager__title home__header has-text-centered">てんちょう</h2>
        <div class="home__contentswrap">

          <div class="manager__wrap has-text-centered">
            <div class="manager__image">
              <router-link :to="`/castinfo/2SXNJZH249NydiwvYflyqEaFsdQ2`">
                <img src="../assets/image/cast/silky.png" width="250" height="250" alt="">
              </router-link>
            </div>
            <div class="manager__name">シルキー・リーヴェ・コスモニア</div>
          </div>

        </div>
      </div>
    </div>

    <div class="section sns">
      <div class="container is-max-widescreen">
        <h2 class="sns__title home__header has-text-centered">えすえぬえす</h2>
        <div class="home__contentswrap">

          <div class="columns">
            <div class="column is-three-fifths is-offset-one-fifth">
              
              <div>
                <a class="twitter-timeline" data-width="100%" data-height="1000" data-theme="light" href="https://twitter.com/elkatsu_info?ref_src=twsrc%5Etfw">Tweets by elkatsu_info</a>
              </div>
              <div style="margin-top:1em;">
              <blockquote class="tiktok-embed" cite="https://www.tiktok.com/@elkatsu_official" data-unique-id="elkatsu_official" data-embed-from="embed_page" data-embed-type="creator" style="max-width: 780px; min-width: 220px;" > <section> <a target="_blank" href="https://www.tiktok.com/@elkatsu_official?refer=creator_embed">@elkatsu_official</a> </section> </blockquote>
              </div>
            </div>
          </div>

        </div>

        <div class="columns is-centered button__area" v-if="userType != 'patron'">
          <div class="column is-half">
            <button disabled style="width:100%;height:50px;margin-inline:auto;background:#ccc;border-radius:9999px;font-size:21px;">えるかつ！無料会員登録</button>
            <p style="color:#fff;font-size:14px;text-align:center;">えるかつ！は9/27をもってサービスを終了致しました。</p>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>


<script>
import { getCastListWithTodayLive } from '@/services/liveServices';
import { mapState } from 'vuex';
import { auth } from '@/plugins/firebase';
import { CAST_LIST } from '@/consts/cast';
import { analyticsLog } from '@/utils/analytics';

// タイルの同時表示数
const tilesNumber = 8;

export default {
  name: 'Home',
  data() {
    return {
      performers: null,
      liveCastList: [],
      castList: CAST_LIST
    };
  },
  async created() {
    const that = this;
    auth.onAuthStateChanged(async user => {
      if (user && !user.emailVerified && !that.$route.path.includes('signup')) {
        that.$router.push('/user/created');
      }
    });
    this.userTypeCheck();
    analyticsLog('TOPページ');
  },
  mounted() {
    const hash = this.$route.hash;
     if (hash && hash.match(/^#.+$/)) {
      setTimeout(() => {
        document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView();
      }, 500);
    }
    setTimeout(() => {
      let tiktokScript = document.createElement('script')
      tiktokScript.setAttribute('src', 'https://www.tiktok.com/embed.js')
      tiktokScript.setAttribute('async', 'true')
      document.head.appendChild(tiktokScript)

      let tweetScript = document.createElement('script')
      tweetScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
      tweetScript.setAttribute('async', 'true')
      document.head.appendChild(tweetScript)
    }, 100)
    
  },
  computed: {
    ...mapState({
      recentLives: state => state.live.recentLives.slice(0, tilesNumber),
      upComingLives: state => state.live.upComingAllLives.slice(0, tilesNumber),
      news: state => state.news.news
    }),
    userType() {
      return this.$store.state.user.userType;
    }
  },
  watch: {
    userType() {
      this.userTypeCheck();
    }
  },
  methods: {
    liveTileClicked(id, type) {
      const path = `/live/streaming/${id}?type=${type}`;
      this.$router.push(path);
    },
    async userTypeCheck() {
      if (this.userType) {
        if (this.userType == 'performer') {
          this.$router.replace('/cast/mypagetop');
        }
        if (this.userType == 'patron') {
          this.liveCastList = await getCastListWithTodayLive();
        }
      }
    },
    nextTo(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/home.scss';
</style>
